import http from "./http";

const formaPagamentoMensal = {
  fetchTiposPagamento: async (payload) => {
    return new Promise((resolve, reject) => {
      http({
        method: "GET",
        url: `parcelasprojeto/tipospagamentos`,
        params: payload,
      })
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },
  save: async (payload) => {
    return new Promise((resolve, reject) => {
      http({
        method: "POST",
        url: `parcelasprojeto`,
        data: payload,
      })
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },
  fetchParcelasPagamento: async (payload) => {
    return new Promise((resolve, reject) => {
      http({
        method: "GET",
        url: `parcelasprojeto/parcelas`,
        params: payload,
      })
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },

  fetchParcelasPagar: async (payload) => {
    return new Promise((resolve, reject) => {
      http({
        method: "GET",
        url: `parcelasprojeto/contaspagar`,
        params: payload,
      })
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },

  fetchParcelasAtrasadas: async (payload) => {
    return new Promise((resolve, reject) => {
      http({
        method: "GET",
        url: `parcelasprojeto/contasatrasadas`,
        params: payload,
      })
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },

  fetchParcelas7Dias: async (payload) => {
    return new Promise((resolve, reject) => {
      http({
        method: "GET",
        url: `parcelasprojeto/contas7dias`,
        params: payload,
      })
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },

  pagarParcela: async (payload) => {
    return new Promise((resolve, reject) => {
      http({
        method: "PUT",
        url: `parcelasprojeto/pagarparcela`,
        data: payload,
      })
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },

  delete: async (payload) => {
    return new Promise((resolve, reject) => {
      http({
        method: "DELETE",
        url: `parcelasprojeto`,
        data: { ...payload }
      })
        .then((resp) => { resolve(resp.data) })
        .catch((error) => { reject(error.response.data) })

    })
  }
}

export default formaPagamentoMensal;
